<template>
  <div id="container">
    <!-- 个性化配置 解决登录预览时菜单栏闪一下的问题 -->
    <div v-if="token && !linkCode && $route.path.indexOf('/auth/project-choice')==-1 && $route.path.indexOf('/auth/role-choice')">
      <TopNav
        :menu="menu"
        :allMenuMark="allMenuMark"
        @reloadEntMenu="reloadEntMenu"
      />
      <EntSelect
        @changeEntInfo="changeEntInfo"
        v-show="ents.length >= 1"
      />
      <ProjectSelect
        @chooseProject="chooseProject"
        v-show="
          isProjectSearch ||
          (proList &&
            proList.length > 0 &&
            !isEntMenu &&
            !$route.path.startsWith('/main') &&
            $route.path != '/main/workBench' &&
            $route.path != '/main/showAllList' &&
            $route.path != '/main/vehicleScheduling' &&
            $route.path != '/main/consumerSafetyIntegration' &&
            $route.path.indexOf('/main/workBench/') == -1) &&
            !$route.path.startsWith('/paymentMerchant')
        "
      />
      <!-- 商户选择器 -->
      <MchSelect v-show="$route.path.startsWith('/paymentMerchant')" />
      <!-- v-if="subMenu && subMenu.length > 0" -->
      <Siderbar @chooseProject="chooseProject" />
      <div
        class="breadcrumb-content breadcrumb-content-top"
        :class="{
          'breadcrumb-content-top': proList && proList.length > 0 && !isEntMenu,
        }"
      >
        <Breadcrumb
          :class="[
            'breadcrumb-container',
            folding ? 'fold-breadcrumb-container' : '',
          ]"
          :menu="menu"
          v-if="menu.length && breadShow"
        />
      </div>

      <!-- 初始化，建议修改密码弹窗 -->
      <init-password
        v-if="initPwdShow"
        @openModal="openInitPwd"
      ></init-password>
    </div>
    <div
      id="subapp-viewport"
      class="subapp-viewport"
      :class="{
        'no-subapp-viewport': $route.path === '/main/m-test',
        'forget-subapp-viewport':
          $route.path === '/auth/forgetPwd' ||
          $route.path.indexOf('/auth/login') != -1 ||
          $route.path.indexOf('/auth/singleLogin') != -1 ||
          $route.path.indexOf('/auth/singleLoginError') != -1 ||
          $route.path.indexOf('/auth/terms') != -1 ||
          $route.path.indexOf('/auth/privacy') != -1 ||
          $route.path === '/main/showAllList' ||
          $route.path === '/main/workBench' ||
          $route.path === '/main' ||
          $route.path === '/auth' ||
          $route.path === '/serviceAlliance/addService' ||
          $route.path === '/serviceAlliance/editService' ||
          $route.path === '/main/consumerSafetyIntegration' ||
          $route.path.indexOf('/auth/project-choice')!=-1 ||
          $route.path === '/main/vehicleScheduling',
        'folding-subapp-viewport': folding,
        'forget-subapp-viewport-spect':
          $route.path === '/serviceAlliance/addService' ||
          $route.path === '/serviceAlliance/editService',
      }"
    ></div>
    <!-- 缓存主应用的路由 -->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <logout
      v-if="token"
      ref="logoutRef"
    />
    <a-modal
      :visible="showInterComRevVisible"
      :closable="false"
      title="云对讲来电提醒"
      okText="去接听"
      cancelText="拒绝"
      dialogClass="interCom-rev-dialog"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p
        class="calle-in-user"
        v-if="callUserInfo"
      >
        {{ DefineIm.USER_TYPE[callUserInfo.goalUserType] }}-{{
          callUserInfo.username
        }}
      </p>
    </a-modal>
    <session-out ref="sessionOutRef" />
    <WarningWindow />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getMenu, getPermCode, getMenuV2 } from "@/api/menu";
import { getPersonalInfo as getPersonalInfoApi } from "@/api/personal.js";
import axios from "axios";
import TopNav from "@/layout/components/TopNav.vue";
import Siderbar from "@/layout/components/Sidebar/index.vue";
import WarningWindow from "@/components/WarningWindow.vue";
import InitPassword from "@/views/modify-password/InitPassword";
import { setStore, getStore, removeStore } from "@/utils/storage";
import { store, event } from "@ice/stark-data";
import { CALLTYPES } from "@/constant";
const color = require("@/styles/theme/variable.js")["primary-color"];
import Logout from "@/components/Logout";
import Stomp from "stompjs";
import SockJS from "sockjs-client";
// import { BASE_URL } from '@/utils/request.js'
import { messageAccountAPi } from "@/api/infromCenter";
import { APPID } from "@/constant";
import TIM from "tim-js-sdk";
import { genUserSign } from "@/api/trtc";
import { message as Toast } from "ant-design-vue";
import SessionOut from "@/components/SessionOut";
import { getAppEnterpriseSesstionTime } from "@/api/projectTree";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import * as DefineIm from "@/utils/DefineIm.js";
import * as DefineRtc from "@/utils/DefineRtc.js";
import EntSelect from "./views/entprise-select/IndexThree.vue";
import { generateProjectName } from "@/constant/projectNameConfig.js";
import { getEnterpriseConfigDetail } from "@/api/projectTree";
// 个性化配置 - 动态换肤
import cssVars from "css-vars-ponyfill"; // css var 的垫片
import ProjectSelect from "./views/new-project-select/IndexThree.vue";
import MchSelect from "./views/new-mch-select/IndexThree.vue"
export default {
  name: "App",
  components: {
    WarningWindow,
    TopNav,
    Siderbar,
    InitPassword,
    Logout,
    SessionOut,
    Breadcrumb,
    EntSelect,
    ProjectSelect,
    MchSelect
  },
  data () {
    return {
      menu: [],
      initPwdShow: false,
      menusCode: [],
      linkCode: undefined,
      trtcCalling: null,
      tim: null,
      im: null,
      loginStatus: 0, //没有登录
      callStatus: "free",
      showInterComRevVisible: false,
      mCallType: CALLTYPES,
      callUserInfo: null,
      inviteID: "",
      rejectInfo: null,
      roomId: "",
      sessionTimer: null,
      currentTime: new Date().getTime(),
      lastTime: new Date().getTime(),
      timeOut: 1 * 60 * 1000, //1 * 60是1秒，设置超时时间： 1分钟--1 分(分钟)=60000 毫秒
      count: 0,
      allMenuMark: [],
      DefineIm: DefineIm,
      Identification: true,
    };
  },
  computed: {
    ...mapState([
      "token",
      "subMenu",
      "folding",
      "projectInfo",
      "entInfo",
      "isFinalApp",
      "appId",
      "isEntMenu",
      "isProjectShow",
      "entClick",
      "ents",
      "proList",
      "isProjectSearch",
      "mchList"
    ]),
    breadShow () {
      return (
        this.$route.path !== "/onlineService/sessionManagement/sessionWindow"
      );
    },
    privateProjectFlag () {
      // 长龙航空私有-项目标识符
      return store.get("privateProjectFlag");
    },
  },
  watch: {
    folding () { },
    token (val) {
      if (val) {
        this.resetMenuData();
        this.getMenu({
          enterpriseId: (this.entInfo && this.entInfo.id) || "",
        });
        this.getPermCode();
        this.getUserInfo();
      } else {
        if (this.stompClient) {
          this.stompClient.unsubscribe();
          this.stompClient.disconnect(() => { });
        }
      }
    },
    $route (to, form) {
      console.log("main ROUTE to = ", to);
      console.log("main ROUTE form = ", form);
      const id = "1.23452384164.123412416";
      const parentDom = document.getElementById("content-container");
      if (document.getElementById(id) !== null) {
        parentDom.removeChild(document.getElementById(id));
      }
      if (to.path === "/auth/login") {
        this.clearSessionTimer();
      }
      if (to.path.indexOf("financialManagement") != -1) {
        this.$store.commit("CHANGE_SUBAPP_NAME", true);
      } else {
        this.$store.commit("CHANGE_SUBAPP_NAME", false);
      }
      if (to.path === "/auth/login" && form.path === "/auth/project-choice") {//跳转到登录页
        removeStore('privateAccessToken')
        removeStore('userInfo')
        removeStore('industryId')
        removeStore('menu')
        removeStore('projectInfo')
        removeStore('kbBaseUrl')
        removeStore('allMenuCode')
        removeStore('curEnterpriseInfo')
        removeStore('allPermCode')
        removeStore('appId')
        removeStore('industryId')
        sessionStorage.removeItem('subCode')
        let getLinkCode = getStore('setLinkCode')
        if (getLinkCode && getLinkCode !== 'undefined') {
          window.location.replace(`${window.location.origin}/auth/login/${getLinkCode}`)
        } else {
          window.location.reload()
        }
      }
      if (to.path === "/auth/login" && form.path === "/auth/role-choice") {//清空缓存跳转到登录页
        removeStore('privateAccessToken')
        removeStore('userInfo')
        removeStore('industryId')
        removeStore('menu')
        removeStore('projectInfo')
        removeStore('kbBaseUrl')
        removeStore('allMenuCode')
        removeStore('curEnterpriseInfo')
        removeStore('allPermCode')
        removeStore('appId')
        removeStore('industryId')
        sessionStorage.removeItem('subCode')
        let getLinkCode = getStore('setLinkCode')
        if (getLinkCode && getLinkCode !== 'undefined') {
          window.location.replace(`${window.location.origin}/auth/login/${getLinkCode}`)
        } else {
          window.location.reload()
        }
      }
    },
    projectInfo: {
      handler (newV) {
        // 如果项目对象存在id属性，就通过项目选择器+企业选择器获取菜单数据
        if (newV.id) {
          this.$nextTick(() => {
            if (!this.isProjectShow) {
              if (this.projectInfo.enterpriseId) {
                this.resetMenuData();
                this.getMenu({
                  projectId: this.projectInfo.id,
                  enterpriseId: this.projectInfo.enterpriseId,
                });
              }
              this.initMoveListener();
              this.initSessionEvent();
              this.getEnterpriseOverTime();
            }
          });
        } else {
          // 否正通过企业选择器获取菜单数据信息
          this.$nextTick(() => {
            if (this.entInfo.id) {
              this.resetMenuData();
              this.getMenu({ enterpriseId: this.entInfo.id });
            }
          });
        }
      },
      immediate: true
    }
  },
  async mounted () {
    // 版本号
    if (
      process.env.VUE_APP_FORMATS === "zbds" ||
      process.env.VUE_APP_FORMATS === "kangYang" ||
      process.env.VUE_APP_FORMATS === "guard"
    ) {
      // 正式环境配置了不显示console.* 这里特殊输出下
      const { log } = console;
      log("版本号：", process.env.version);
    }
    const { log } = console;
    log("主应用版本号：", process.env.version);
    console.log('-------------------update code-------------')
    const configServices = await axios.get("/config/config.json");
    const dynamicLink = `${document.location.protocol}//${document.location.hostname}:${configServices.port}`;
    const targetBaseUrl =
      process.env.VUE_APP_MODE == "development" ||
        process.env.VUE_APP_MODE == "dev"
        ? configServices["default"]["development"].common
        : dynamicLink;
    store.set('targetBaseUrl', targetBaseUrl)
    const sdkAppIdEnums = {
      "development": '1600020417',
      "test": '1600020417',
      // "pre": '1400694207',
      // "production": '1400677520'
      "pre": '1600020417',
      "production": '1600020417'
    }
    const sdkAppId = sdkAppIdEnums[process.env.VUE_APP_MODE]
    store.set('sdkAppId', sdkAppId)
    /* 个性化配置 解决登录预览时菜单栏闪一下的问题 start */
    const pathNameItem = window.location.pathname.split("/");
    this.linkCode =
      pathNameItem[pathNameItem.length - 1] !== "login" &&
        pathNameItem[pathNameItem.length - 3] === "auth"
        ? pathNameItem[pathNameItem.length - 1]
        : undefined;
    if (this.token) {
      this.linkCode = undefined
    }
    /* 个性化配置 解决登录预览时菜单栏闪一下的问题 end */
    await this.dispatchMainColor();
    this.initMenuRefreshEvent();
    if (this.token) {
      this.getUserInfo();
      const appId = getStore("appId");
      const industryId = getStore("industryId");
      const accessToken = getStore("privateAccessToken");
      const BASE_URL = store.get("allServiceInfo");
      this.socket = new SockJS(
        `${targetBaseUrl}/cent-message/private?appId=${appId}&industryId=${industryId}&accessToken=${accessToken}&clientType=3`,
        null
      );
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.heartbeat.incoming = 10000;
      this.stompClient.heartbeat.outgoing = 0;
      this.initHangUpListener();
    } else {
      if (process.env.VUE_APP_ENV == "xmtyg") {
        //跳转回到厦门体育馆自己的门户
        //就调用他们那边的退出登录接口(单独处理厦门体育馆登出操作),getStore("formSingle")
        if (location.href.indexOf('auth/singleLogin') == -1) {
          window.location.replace("https://10.20.203.16:9443/auth/singleLogin");
        }
      }
    }
  },
  beforeDestroy () {
    this.loginStatus = 0;
    this.callStatus = "free";
    this.inviteID = "";
    if (this.trtcCalling) {
      this.trtcCalling.logout();
    }
    this.removeListener();
    if (this.appId === "202105248183") {
      this.removeImListener();
    }
  },
  created () {
    this.setIconFavicon();
  },
  methods: {
    setFaviconDom (path) {
      const link =
        document.getElementById("favicon") || document.createElement("link");
      link["type"] = "image/x-icon";
      link["rel"] = "shortcut icon";
      link["href"] = require(`@/assets/images/common/${path}`);
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    setIconFavicon () {
      const eumn = {
        kl: () => {
          this.setFaviconDom("kl-logo.png");
        },
      };
      eumn[process.env.VUE_APP_ENV]?.();
    },
    olorRgb (color) {
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      var sColor = color.toLowerCase();
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        //处理六位的颜色值
        var sColorChange = [];
        for (var i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return "rgba(" + sColorChange.join(",") + ", .1)";
      } else {
        return sColor;
      }
    },
    changeCustomTheme (defaultMainColor) {
      let docEle = document.documentElement;
      const auTheme = {
        "--theme-color": defaultMainColor || color,
        "--theme-alpha-color":
          this.olorRgb(defaultMainColor) || this.olorRgb(color),
      };
      // 批量覆盖样式
      for (const key in auTheme) {
        if (auTheme.hasOwnProperty(key)) {
          const value = auTheme[key];
          // 关键
          docEle.style.setProperty(key, value);
        }
      }
      docEle = null;
    },
    isIE () {
      if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
      else return false;
    },
    getEnterpriseConfigDetails (data) {
      const params = {
        enterpriseId: data.id,
        industryId: getStore("industryId"),
      };
      getEnterpriseConfigDetail(params)
        .then((res) => {
          let markedMenu = [];
          if (res.code === 1000) {
            setTimeout(() => {
              document.title = res?.result?.name || generateProjectName();
            }, 1000);
            this.$store.commit(
              "M_CUR_LOGO",
              res?.result?.logoUrl ||
              require("@/assets/images/common/defaultLogo.png")
            );
            if (res?.result?.openStatus == 1) {
              //加水印
              this.$nextTick(() => {
                setTimeout(() => {
                  if (this.allMenuMark.length > 0) {
                    this.allMenuMark.forEach((i) => {
                      if (res?.result?.permissionId) {
                        res?.result?.permissionId.split(",").forEach((j) => {
                          if (i.id == j) {
                            markedMenu.push(i);
                          }
                        });
                      }
                    });
                    store.set("allMarkMenu", markedMenu);
                  } else {
                    store.set("allMarkMenu", undefined);
                  }
                }, 1000);
              });
              store.set("defaultMainColor", res?.result?.themeColor || color);
              this.changeCustomTheme(res?.result?.themeColor || color);
            } else {
              store.set("allMarkMenu", undefined);
              document.title = generateProjectName();
              store.set("defaultMainColor", res?.result?.themeColor || color);
              this.changeCustomTheme(res?.result?.themeColor || color);
            }
            const link =
              document.querySelector('link[rel*="icon"]') ||
              document.createElement("link");
            link.type = "image/x-icon";
            link.rel = "shortcut icon";
            link.href = res.result.icoUrl;
            document.getElementsByTagName("head")[0].appendChild(link);
            if (this.isIE()) {
              setTimeout(() => {
                this.changeCustomTheme(res.result?.themeColor || color);
                cssVars({
                  watch: true,
                });
              }, 0);
            } else {
              store.set("defaultMainColor", res?.result?.themeColor || color);
              this.changeCustomTheme(res?.result?.themeColor || color);
            }
          } else {
            document.title = generateProjectName();
            store.set("defaultMainColor", color);
            this.changeCustomTheme(color);
          }
        })
        .catch(() => {
          document.title = generateProjectName();
          store.set("defaultMainColor", color);
          this.changeCustomTheme(color);
        });
    },
    changeEntInfo (entInfo) {
      this.reloadEntMenu(entInfo.id);
      this.$nextTick(() => {
        this.getEnterpriseConfigDetails(entInfo);
      });
    },
    initMoveListener () {
      document.addEventListener("mouseover", () => {
        this.handleMouseEvent();
      });
    },
    initMenuRefreshEvent () {
      event.on("freshMenu", () => {
        if (this.projectInfo.enterpriseId) {
          this.resetMenuData();
          this.getMenu({
            projectId: (this.projectInfo && this.projectInfo.id) || "",
            enterpriseId: this.projectInfo.enterpriseId,
          });
        }
      });
      event.on('refreshMyInfo', () => {
        this.getUserInfo()
      })
    },
    async getInformAccount () {
      const { code, message, result } = await messageAccountAPi({
        categoryCode: ["alarm", "system", "biz_notice"],
        isRead: false,
        channels: ["WEBSOCKET"],
      });
      if (code === 1000) {
        this.$store.dispatch("messageCenterCount", result.total);
      } else {
        this.$message.warning("消息数量获取失败！");
      }
    },
    async dispatchMainColor () {
      // 红线问题:由于不能出现过多无关环境域名，需做以下操作
      // 1.根据是否已登陆 判断加载config.json或是config_auth
      // 2.运行环境默认加载通配符所在环境["default"]['development']
      // 3.运维将通配符配置文件 config_wildcard.json 替换掉 config.json ，config_auth_wildcard.json 替换掉 config_auth.json
      // 4.构建
      let mDataJosn;
      if (getStore("privateAccessToken")) {
        mDataJosn = await axios.get("/config/config.json");
      } else {
        mDataJosn = await axios.get("/config/config_auth.json");
      }

      const formatsMsg = await axios.get("/config/formats.json");
      const formatsData = process.env.VUE_APP_FORMATS
        ? formatsMsg[process.env.VUE_APP_FORMATS]
        : formatsMsg["default"];
      store.set("defaultMainColor", formatsData.defaultTheme.defaultMainColor);
      store.set("industryColor", formatsData.defaultTheme.defaultMainColor);
      store.set("activeBgColor", formatsData.defaultTheme.activeBgColor);

      const cfgServices =
        (process.env.VUE_APP_ENV
          ? mDataJosn?.[process.env.VUE_APP_ENV]
          : mDataJosn["default"]) || mDataJosn["default"];

      store.set(
        "allServiceInfo",
        cfgServices[process.env.VUE_APP_MODE]
          ? cfgServices[process.env.VUE_APP_MODE]
          : cfgServices["development"]
      );
      setStore(
        "kbBaseUrl",
        cfgServices[process.env.VUE_APP_MODE]
          ? cfgServices[process.env.VUE_APP_MODE]["common"]
          : cfgServices["development"]["common"]
      );
      store.set("mainProjectName", formatsData.mainProjectName);
      store.set(
        "privateProjectFlag",
        process.env.VUE_APP_ENV || process.env.VUE_APP_FORMATS
      );
    },
    connectSocket () {
      const _this = this;
      const userInfo = JSON.parse(getStore("userInfo"));
      this.stompClient.connect(
        {},
        () => {
          this.stompClient.subscribe(
            `/user/${userInfo.id}/message`,
            function (response) {
              const responseBody = JSON.parse(response.body);
              if (responseBody.code === "accountLoginOut") {
                _this.stompClient.unsubscribe();
                _this.stompClient.disconnect(() => { });
                _this.$refs["logoutRef"].handleShowDialog();
              } else {
                _this.getInformAccount();
                //  监听空间管理导入结果
                if (responseBody.title === "UPLOAD_SPACE_FINISHED") {
                  // store.set("spaceImportResult", response.body);
                  event.emit('spaceImportResult', response.body)
                }
                //  监听组织管理导入结果
                if (responseBody.title === "UPLOAD_ORGANIZATION_FINISHED") {
                  store.set("orgImportResult", response.body);
                }
              }
              //  监听云对讲文件导入结果
              if (responseBody?.params?.type === "TALK_BACK_MESSAGE") {
                store.set("cloudImportResult", response.body);
              }
              // 监听中建五局绩效考核导入结果
              if (responseBody?.title === "UPLOAD_CHECK_PLAN_FINISHED") {
                store.set("uploadCheckPlanFinished", response.body);
              }
              // 监听企业通讯录批量导入员工结果
              if (responseBody?.title === 'UPLOAD_STAFF_FINISHED') {
                event.emit('space_import', response.body)
                // store.set('space_import', response.body)
              }
            }
          );
          console.log("项目标识符:" + store.get("privateProjectFlag"));
          if (store.get("privateProjectFlag") === "guard") {
            // 判断是否是长龙航空项目
            // 告警弹窗接收消息
            // this.stompClient.subscribe("", function(response) {
            //   // 解析response，存入store
            //   console.log(response);
            // })
            console.log("开始接收告警弹窗列表");
            let alarmMessageList = [
              {
                urgencyLevel: "紧急", // 紧急程度
                warningEventName: "黑名单人员进入", // 告警事件名称
                deviceName: "设备名称", // 设备名称
                time: "2023-03-23 12:12:34", // 告警时间
                content: "告警内容告警内容", // 告警内容
              },
              {
                urgencyLevel: "一般", // 紧急程度
                warningEventName: "黑名单人员进入", // 告警事件名称
                deviceName: "设备名称", // 设备名称
                time: "2023-03-23 12:12:34", // 告警时间
                content: "告警内容告警内容", // 告警内容
              },
            ];
            this.$store.commit("SET_ALARM_MESSAGE_LIST", alarmMessageList);
            setTimeout(() => {
              let newAlarmMessageList = [
                {
                  urgencyLevel: "紧急", // 紧急程度
                  warningEventName: "黑名单人员进入111111", // 告警事件名称
                  deviceName: "设备名称", // 设备名称
                  time: "2023-03-23 12:12:34", // 告警时间
                  content: "告警内容告警内容", // 告警内容
                },
              ];
              this.$store.commit("SET_ALARM_MESSAGE_LIST", [
                ...newAlarmMessageList,
                ...this.$store.state.alarmMessageList,
              ]);
              console.log("接收到消息");
            }, 7000);
          }
        },
        _this.errorCallback
      );
    },
    errorCallBack (err) {
      this.connectSocket();
    },
    resetMenuData () {
      this.menu.length = 0;
      this.menusCode.length = 0;
      this.$store.commit("SET_SUBMENU", []);
      removeStore("menu");
    },
    getMenu (data) {
      setStore("refresh", true);
      if (!data.enterpriseId) {
        return;
      }
      let projectInfo = null;
      if (getStore("projectInfo") && getStore("projectInfo") != "undefined") {
        projectInfo = JSON.parse(getStore("projectInfo"));
      }
      if (projectInfo?.id) {
        if (!data.hasOwnProperty("projectId")) {
          data.projectId = projectInfo?.id;
        }
      }
      getMenuV2(data)
        .then((res) => {
          const { code, result } = res;
          if (code === 1000) {
            const mResult = result.map((o) => {
              if (o.homeFlag == 1) {
                o.menuType = 1
                o.menuUrl = '/main/test'
                o.code = 'home'
              }
              return o
            })
            this.menu = mResult;
            this.dealMenu(mResult);
            setStore("allMenuCode", this.menusCode);
            setStore("allPermCode", this.menusCode);
            localStorage.setItem("menu", JSON.stringify(result));
            if (this.entClick) {
              removeStore("refresh");
              location.reload();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dealMenu (menus = []) {
      menus.forEach((menu) => {
        this.menusCode.push(menu.code);
        if (menu.menuType != 0) {
          this.allMenuMark.push(menu);
        }
        if (menu.children.length > 0) {
          this.dealMenu(menu.children);
        }
      });
    },
    getPermCode (projectId) {
      getPermCode(projectId)
        .then((res) => {
          const { code, result } = res;
          if (code === 1000) {
            let allPermCode = result.map((menu) => menu.code);
            setStore("allPermCode", allPermCode);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initHangUpListener () {
      event.on("freshHangUp", (flag, isOver) => {
        if (flag) {
          this.callStatus = "free";
        }
        if (isOver) {
          this.trtcCalling && this.trtcCalling.hangup();
        }
      });
    },
    handleOk () {
      this.showInterComRevVisible = false;
      store.set("imCallInfo", {
        status: DefineIm.CALL_STATUS.CALLED,
        callGoal: this.callUserInfo.fromUserId,
        roomCode: this.callUserInfo.roomId,
        isCallTo: false,
        goalDeviceType: this.callUserInfo.goalDeviceType,
        goalUserType: this.callUserInfo.goalUserType,
        goalName: this.callUserInfo.username,
        headImage: this.callUserInfo.headImage,
        callTime: "",
        talkStartTime: "",
        talkEndTime: "",
        cameraRotation: this.callUserInfo.cameraRotation,
        openDoorId: this.callUserInfo.openDoorId,
      });
      window.history.pushState({}, "", "/interCom/bisMgt");
    },
    resetTrtcInfo () {
      this.callUserInfo = null;
      this.rejectInfo = null;
      this.callStatus = "free";
    },
    async handleCancel () {
      this.showInterComRevVisible = false;
      // if (this.callStatus && this.rejectInfo) {
      //   this.trtcCalling.reject({
      //     ...this.rejectInfo
      //   })
      //   this.$message.warning('已拒绝通话')
      // }
      // this.resetTrtcInfo()
      this.im.sendMessage(this.callUserInfo.fromUserId, {
        text: JSON.stringify({ msgType: DefineIm.IM_MSG_TYPE.REJECT }),
      });
      Toast.warning("已拒绝通话");
    },
    initTRTC (tim, sdkAppId) {
      const options = {
        SDKAppID: sdkAppId,
        tim,
      };
      return new TRTCCalling(options);
    },
    async handleRealLogin (userId, trtcCalling) {
      const r = await genUserSign(userId);
      try {
        await trtcCalling.login({
          userID: `${userId}`,
          userSig: `${r.result}`,
        });
      } catch (e) { }
    },
    async initIm (userInfo) {
      if (this.im || !userInfo?.id) {
        return;
      }
      store.set("defineIm", DefineIm);
      this.im = new DefineIm.Im();
      const r = await genUserSign(userInfo.id);
      this.im.login(`${userInfo.id}`, r.result);
      store.set("im", this.im);
      console.info(this.im);
      store.set("imCallInfo", this.im.imCallInfo);

      store.set("defineRtc", DefineRtc);
      console.info(DefineRtc);

      this.addImListener();
    },
    addImListener () {
      this.im.on(TIM.EVENT.MESSAGE_RECEIVED, this.onMessageReceived);
    },
    removeImListener () {
      this.im.off(TIM.EVENT.MESSAGE_RECEIVED, this.onMessageReceived);
    },
    onMessageReceived (msgData) {
      if (location.href.indexOf("/interCom/bisMgt") != -1) {
        return;
      }

      const msgType = msgData.msgType;

      if (!msgType) {
        return;
      }
      if (msgType === DefineIm.IM_MSG_TYPE.CALL_TO) {
        let cameraRotation = 0;
        let openDoorId = "";
        try {
          cameraRotation = JSON.parse(msgData?.msg).camera_rotation;
          openDoorId = JSON.parse(msgData?.msg).id;
        } catch (error) {
          // cameraRotation = 0;
        }

        this.callUserInfo = {
          headImage:
            msgData?.callFromHead ||
            require("@/assets/images/interCom/call-user--default-avator.svg"),
          username: msgData?.name,
          mTalkTypeId: msgData?.msgType,
          roomId: msgData.roomCode,
          fromUserId: msgData?.from,
          goalDeviceType: msgData?.deviceType,
          goalUserType: msgData?.userType,
          cameraRotation,
          openDoorId,
        };
        this.showInterComRevVisible = true;
      } else if (msgType === DefineIm.IM_MSG_TYPE.PRE_HANG_ON) {
        this.showInterComRevVisible = false;
        Toast.warning("对方已取消通话");
      }
    },
    // 腾讯trtcCalling登录处理
    trtcLogin (userInfo) {
      if (this.loginStatus) {
        return;
      }
      const options = {
        SDKAppID: APPID,
      };
      this.tim = TIM.create(options);
      this.trtcCalling = this.initTRTC(this.tim, APPID);
      this.handleRealLogin(userInfo.id, this.trtcCalling);
      this.loginStatus = 1;
      const t = {
        tim: this.tim,
        trtcCalling: this.trtcCalling,
      };
      store.set("trtcCallInfos", t);
      this.initListener();
    },
    initListener () {
      if (!this.trtcCalling) return;
      this.trtcCalling.on(TRTCCalling.EVENT.ERROR, this.handleError);
      this.trtcCalling.on(TRTCCalling.EVENT.INVITED, (e) =>
        this.handleInvited(e, 1)
      );
      this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, (e) => this.handleRevMsg(e));
      this.trtcCalling.on(TRTCCalling.EVENT.REJECT, this.handleEject);
      this.trtcCalling.on(TRTCCalling.EVENT.NEW_INVITATION_RECEIVED, (e) =>
        this.handleInvited(e, 2)
      );
      this.trtcCalling.on(TRTCCalling.EVENT.USER_ENTER, (e) =>
        this.handleUserEnter(e)
      );
      this.trtcCalling.on(
        TRTCCalling.EVENT.CALLING_CANCEL,
        this.handleCallingCancel
      );
      this.trtcCalling.on(TRTCCalling.EVENT.LINE_BUSY, (e) =>
        this.handleLineBusy(e)
      );
    },
    // 移除监听
    removeListener () {
      if (!this.trtcCalling) return;
      this.trtcCalling.off(TRTCCalling.EVENT.ERROR, this.handleError);
      this.trtcCalling.off(TRTCCalling.EVENT.INVITED, (e) =>
        this.handleInvited(e, 1)
      );
      this.tim.off(TIM.EVENT.MESSAGE_RECEIVED, (e) => this.handleRevMsg(e));
      this.trtcCalling.off(TRTCCalling.EVENT.REJECT, this.handleEject);
      this.trtcCalling.off(TRTCCalling.EVENT.NEW_INVITATION_RECEIVED, (e) =>
        this.handleInvited(e, 2)
      );
      this.trtcCalling.off(TRTCCalling.EVENT.USER_ENTER, (e) =>
        this.handleUserEnter(e)
      );
      this.trtcCalling.off(
        TRTCCalling.EVENT.CALLING_CANCEL,
        this.handleCallingCancel
      );
      this.trtcCalling.off(TRTCCalling.EVENT.LINE_BUSY, (e) =>
        this.handleLineBusy(e)
      );
    },
    // 处理忙线
    async handleLineBusy (e) { },
    async handleRevMsg (event) {
      //接收到了消息
      const _this = this;
      if (location.href.indexOf("/interCom/bisMgt") != -1) {
        //有
        return;
      }
      if (_this.callStatus == "called") {
        return;
      }
      const { data } = event;
      let msgInfo = null;
      if (data[0].payload.data) {
        msgInfo = JSON.parse(data[0].payload.data);
        if (msgInfo.hasOwnProperty("callFromHead")) {
          _this.callUserInfo = {
            headImage:
              msgInfo?.callFromHead ||
              require("@/assets/images/interCom/call-user--default-avator.svg"),
            username: msgInfo?.callFromName,
            mTalkType: msgInfo?.callFromTypeName,
            mTalkTypeId: msgInfo?.callFromType,
            roomId: _this.roomId,
          };
          _this.callStatus = "called";
          _this.showInterComRevVisible = true;
        }
      } else if (data[0].payload.text) {
        msgInfo = JSON.parse(data[0].payload.text);
        if (
          msgInfo.hasOwnProperty("callFromHead") &&
          msgInfo.hasOwnProperty("callTo")
        ) {
          _this.callUserInfo = {
            headImage:
              msgInfo?.callFromHead ||
              require("@/assets/images/interCom/call-user--default-avator.svg"),
            username: msgInfo?.callFromName,
            mTalkType: msgInfo?.callFromTypeName,
            mTalkTypeId: msgInfo?.callFromType,
            roomId: _this.roomId,
          };
          _this.callStatus = "called";
          _this.showInterComRevVisible = true;
        }
      }
    },
    async handleUserEnter () { },
    async handleCallingCancel () {
      Toast.warning("对方已取消通话");
      this.showInterComRevVisible = false;
      this.resetTrtcInfo();
    },
    async handleEject ({ userID }) {
      this.handleCancel();
    },
    async handleInvited (
      { sponsor, userIDList, isFromGroup, inviteData, inviteID },
      flag
    ) {
      const userInfo = JSON.parse(getStore("userInfo"));
      const { callType, roomID } = inviteData; // 1：语音通话，2：视频通话
      this.inviteID = inviteID;
      this.roomId = roomID;
      if (this.callStatus === "called") {
        await this.trtcCalling.reject({
          inviteID,
          isBusy: true,
          callType: inviteData.callType,
        });
        return;
      }

      this.rejectInfo = {
        inviteID,
        isBusy: false,
        callType: inviteData.callType,
      };
      // const promise = this.tim.getMessageList({conversationID: `C2C${sponsor}`, count: 15});
      // promise.then(function(imResponse) {
      //   const messageList = imResponse.data.messageList; // 消息列表。
      //   if(Array.isArray(messageList) && messageList.length > 0) {
      //     messageList.forEach((i) => {
      //       let msgInfo = null
      //       if(i.payload.data && i.payload.data?.indexOf('callFromHead') != -1 && i.payload.data?.indexOf('inviteID') ==-1) {
      //         msgInfo = JSON.parse(i.payload.data)
      //         if(userInfo.id != sponsor) {
      //           _this.callUserInfo = {
      //             headImage: msgInfo?.callFromHead || require('@/assets/images/interCom/call-user--default-avator.svg'),
      //             username: msgInfo?.callFromName,
      //             mTalkType: msgInfo?.callFromTypeName,
      //             mTalkTypeId: msgInfo?.callFromType,
      //             roomId: roomID
      //           }
      //           _this.callStatus = 'called'
      //           _this.showInterComRevVisible = true
      //         }
      //       }
      //       if(i.payload.text != undefined && i.payload.text.indexOf('callTo') !==-1) { //有，存在
      //         msgInfo = JSON.parse(i.payload.text)
      //         if(userInfo.id != sponsor) {
      //           _this.callUserInfo = {
      //             headImage: msgInfo?.callFromHead || require('@/assets/images/interCom/call-user--default-avator.svg'),
      //             username: msgInfo?.callFromName,
      //             mTalkType: msgInfo?.callFromTypeName,
      //             mTalkTypeId: msgInfo?.callFromType,
      //             roomId: roomID
      //           }
      //           _this.callStatus = 'called'
      //           _this.showInterComRevVisible = true
      //         }
      //       }

      //     })
      //   }
      // });
    },
    handleError () { },
    // 获取个人信息
    getUserInfo () {
      getPersonalInfoApi()
        .then((res) => {
          if (res.code === 1000) {
            if (!res.result.isLogged) {
              //如果没有修改密码，则强制进行修改密码处理
              removeStore("privateAccessToken");
              location.reload();
            }
            // 水印上需要展示的内容
            store.set(
              "waterMarkTip",
              `${res.result.name} ${res.result.phone
                .split("")
                .reverse()
                .join("")
                .substr(0, 4)}`
            );
            setStore("userInfo", JSON.stringify(res.result));
            this.connectSocket();
            // this.trtcLogin(res.result)
            // 住宅
            if (this.appId === "202105248183") {
              this.initIm(res.result);
            }
            this.$store.commit("SET_USERINFO", res.result);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    openInitPwd (boolean) {
      if (typeof boolean === "boolean") {
        this.initPwdShow = boolean;
      }
    },
    reloadEntMenu (id) {
      this.getUserInfo();
      this.getPermCode({ enterpriseId: id });
    },
    reloadMenu (id) {
      this.getUserInfo();
      this.getPermCode({ projectId: id });
    },
    async getEnterpriseOverTime () {
      if (!this.projectInfo.enterpriseId) {
        return;
      }
      const params = {
        enterpriseId: this.projectInfo.enterpriseId,
      };
      try {
        const { code, result } = await getAppEnterpriseSesstionTime(params);
        if (code === 1000) {
          if (result.limitTimeUnit == 1) {
            //分钟-转换为毫秒
            this.timeOut = result.sessionLimitTime * 60 * 1000;
            this.initSessionTimer();
          } else if (result.limitTimeUnit == 2) {
            //小时-转换为毫秒
            this.timeOut = result.sessionLimitTime * 60 * 60 * 1000;
            this.initSessionTimer();
          } else {
            // 天数转换为毫秒
            this.timeOut = result.sessionLimitTime * 60 * 60 * 1000 * 24;
            this.initSessionTimer();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    initSessionTimer () {
      this.sessionTimer = setInterval(() => {
        this.watchTimer();
      }, 1000);
    },
    handleMouseEvent () {
      this.lastTime = new Date().getTime();
      this.count = 0;
    },
    initSessionEvent () {
      event.on("refreshSessionTime", (enId) => {
        if (enId == this.projectInfo.enterpriseId) {
          this.clearSessionTimer();
          this.getEnterpriseOverTime();
        }
      });
    },
    clearSessionTimer () {
      clearInterval(this.sessionTimer);
      this.sessionTimer = null;
      this.currentTime = this.lastTime = new Date();
    },
    watchTimer () {
      this.currentTime = new Date().getTime();
      ++this.count;
      if (this.currentTime - this.lastTime > this.timeOut) {
        //判断是否超时
        event.emit("logout");
        this.$refs["sessionOutRef"].handleShowDialog();
        this.clearSessionTimer();
      }
    },
    chooseProject () { },
  },
};
</script>

<style lang="less">
#container {
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

.less-error-message {
  display: none;
}

.subapp-viewport {
  height: calc(~'100% - 108px') !important;
  width: calc(~'100% - 226px') !important;
  margin-left: 226px;
  // padding-top: 56px;
  background-color: #f5f5f5;

  > div {
    height: 100%;
    width: 100%;
  }
}

.forget-subapp-viewport {
  width: 100% !important;
  margin-left: 0px;
  padding-top: 0 !important;
}

.folding-subapp-viewport {
  width: calc(~'100% - 50px') !important;
  margin-left: 50px;
}

.bread-crumb-container {
  top: 56px !important;
  left: 228px !important;
  width: 100% !important;
  /* width: calc(~ 100% - 250px ) !important; */
}

.breadcrumb-content {
  .breadcrumb-container {
    height: 50px;
    line-height: 50px !important;
    padding-left: 240px !important;
    padding-bottom: 12px !important;
  }
}

.breadcrumb-content-top {
  padding-top: 56px !important;
}

#container .fold-breadcrumb-container {
  // margin-top: 56px !important;
  padding-left: 65px !important;
  background-color: #fff !important;
  padding-bottom: 12px !important;
}

.forget-subapp-viewport {
  width: 100% !important;
  display: block;
  margin-left: 0 !important;
  margin-top: 0 !important;
  height: 100% !important;
}

.forget-subapp-viewport-spect {
  height: auto !important;
}

.is-final-app {
  height: calc(~'100%') !important;
  padding-top: 58px;
}
</style>
